export const showBubbleContests = {
    'demo': [],
    'gr': ['Apple iPhone 11'],
    'gr-mobimilia': ['Apple iPhone 11']
}